/** POS komisyonunun oran mı sabit tutar mı olduğunu belirler. */
export enum PosCommissionValueType {
    Rate = 0,
    FixedAmount = 1
}
